import { useMemo } from 'react'

export function GetStatusStyle(value: string) {
  const style = useMemo(
    () =>
      value === 'CompletedWithErrors'
        ? {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#FDF1D3',
            color: '#2C4757',
            border: 'solid 1px #F9B93B',
          }
        : value === 'Failed'
        ? {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#F7D7D3',
            color: '#2C4757',
            border: 'solid 1px #D93B27',
          }
        : value === 'Completed'
        ? {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#D9F0E7',
            color: '#2C4757',
            border: 'solid 1px #3DB786',
          }
        : {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#D9F0E7',
            color: '#2C4757',
            border: 'solid 1px #3DB786',
          },
    [value],
  )

  return style
}
